import React from "react";
import "../styles/HeroSection.css";
import Footer from "../components/Footer";
import RightSection from "../components/RightSection";
import LeftSection from "../components/LeftSection";
import SiteHeader from "../components/SiteHeader";
import GoingOutSection from "../components/GoingOutSection";

const HeroSection = () => {
  return (
    <>
      <div className="hero-container">
        <SiteHeader />
        <LeftSection />
        <RightSection />
        <Footer />
      </div>
      <GoingOutSection />
    </>
  );
};

export default HeroSection;
